import { compact } from 'lodash';
import { FetchStaffProps, StaffProps } from '../types';
import { Status } from '../../../enums';

const transformFetchStaffUsers = (staffs: FetchStaffProps): StaffProps[] => {
  return compact(
    staffs.data.map((staff) => {
      return staff?.status === Status.ACTIVE
        ? {
            id: staff.id,
            name: staff.name,
            email: staff.email,
            gender: staff.gender,
            profile: staff.profile,
            memberCode: staff.memberCode
          }
        : undefined;
    })
  );
};

const transformStaffDetailData = (data: any) => {
  const currentDate = new Date();
  const currentCourseInfo = data?.courseInfo?.find(
    (courseInfo: { academicYear: { from: string; to: string } }) => {
      const { from, to } = courseInfo.academicYear;
      return currentDate >= new Date(from) && currentDate <= new Date(to);
    }
  );

  const currentAcademicYear = `${new Date(
    currentCourseInfo?.academicYear?.from
  ).getFullYear()}-${new Date(
    currentCourseInfo?.academicYear?.to
  ).getFullYear()}`;

  return {
    ...data,
    currentCourseInfo,
    currentAcademicYear,
    memberCode: data?.memberCode
  };
};

export { transformFetchStaffUsers, transformStaffDetailData };
